import { useEffect } from 'react'
import { dashboardURL } from '../../utils/constants'

const DefaultPage = () => {
  useEffect(() => {
    window.location.replace(dashboardURL)
  }, [])

  return null
}

export default DefaultPage
